(function() { window.GUID_1be2a2c2_0a3a_4925_9d31_aa76574000b1 = { getGuid: function() { return "1be2a2c2-0a3a-4925-9d31-aa76574000b1"; } }; })();
var CompuSport;
(function (CompuSport) {
    var Controls;
    (function (Controls) {
        class PlayerEntityTransferer {
            constructor(popup) {
                this.popup = popup;
            }
            initialize() {
                this.bindApplyToAllButtons();
                this.bindResetButton();
                this.bindAutocompletes();
                this.bindSaveButtonClick();
            }
            bindApplyToAllButtons() {
                const $buttons = this.popup.Content.find(".apply-to-all-btn");
                if (!$buttons.length) {
                    return;
                }
                $buttons.on("click", this.handleApplyToAllButtonClick.bind(this));
            }
            handleApplyToAllButtonClick(event) {
                const $button = $(event.target);
                const playerId = $button.data("player-id");
                const $radios = this.popup.Content.find(`input[type="radio"][value="${playerId}"]`);
                $radios.prop("checked", true);
            }
            bindResetButton() {
                const $button = this.popup.Content.find(".reset-btn");
                if (!$button.length) {
                    return;
                }
                $button.on("click", this.handleResetButtonClick.bind(this));
            }
            handleResetButtonClick() {
                const $radios = this.popup.Content.find("input[type='radio']");
                const $defaultRadios = $radios.filter((_, radio) => $(radio).data("is-default") == "True");
                $defaultRadios.prop("checked", true);
            }
            bindSaveButtonClick() {
                const $button = $("#PlayerEntityTransfererSaveButton");
                if (!$button.length) {
                    return;
                }
                $button.on("click", this.handleSaveButtonClick.bind(this));
            }
            handleSaveButtonClick() {
                const data = this.collectData();
                if (data == null) {
                    console.log("No data to save");
                    return;
                }
                CompuSport.Ajax.Post(CSParameters.RUrl + "Shared/PlayerEntityTransferer/", { data: JSON.stringify(data) }, (result) => {
                    if (result.success) {
                        this.popup.Close();
                    }
                    else {
                        console.error(result.error);
                    }
                });
            }
            collectData() {
                const $rows = this.popup.Content.find(".entity-rows .row");
                if ($rows.length === 0) {
                    return null;
                }
                const data = [];
                $rows.each((_, row) => {
                    const $entityForm = $(row).find(".entity-form");
                    const $playerForm = $(row).find(".player-form");
                    if ($entityForm.length === 0 || $playerForm.length === 0) {
                        return;
                    }
                    const EntityBaseId = $entityForm
                        .find("input[name='EntityBaseId']")
                        .val();
                    const _TeamId = $entityForm.find("input[name='TeamId']").val();
                    const _EventId = $entityForm.find("input[name='EventId']").val();
                    const _StatGroupId = $entityForm
                        .find("input[name='StatGroupId']")
                        .val();
                    const _FlowBlockId = $entityForm
                        .find("input[name='FlowBlockId']")
                        .val();
                    const _PlayerId = $playerForm.find("input[type='radio']:checked").val();
                    const TeamId = isNaN(Number(_TeamId)) ? null : Number(_TeamId);
                    const EventId = isNaN(Number(_EventId)) ? null : Number(_EventId);
                    const StatGroupId = isNaN(Number(_StatGroupId))
                        ? null
                        : Number(_StatGroupId);
                    const FlowBlockId = isNaN(Number(_FlowBlockId))
                        ? null
                        : Number(_FlowBlockId);
                    const PlayerId = isNaN(Number(_PlayerId)) ? null : Number(_PlayerId);
                    data.push({
                        EntityBaseId,
                        TeamId,
                        EventId,
                        StatGroupId,
                        FlowBlockId,
                        PlayerId,
                    });
                });
                return data;
            }
            bindAutocompletes() {
                const $autocompletes = this.popup.Content.find(".player-picker input.CSDefault[id*='AutoComplete']");
                if (!$autocompletes.length) {
                    return;
                }
                $autocompletes.each((_, input) => {
                    const autocomplete = $(input).data("context");
                    autocomplete.HiddenValue.on("change", () => {
                        const newValue = autocomplete.HiddenValue.val();
                        if (newValue) {
                            const $radio = $(input)
                                .closest(".radio")
                                .find(`input[type="radio"]`);
                            $radio.val(newValue);
                            $radio.prop("checked", true);
                        }
                        else {
                            const $closestForm = $(input).closest("form");
                            const $defaultRadio = $closestForm.find(`input[type="radio"][data-is-default="True"]`);
                            $defaultRadio.prop("checked", true);
                        }
                    });
                });
            }
        }
        Controls.PlayerEntityTransferer = PlayerEntityTransferer;
    })(Controls = CompuSport.Controls || (CompuSport.Controls = {}));
})(CompuSport || (CompuSport = {}));

//# sourceMappingURL=PlayerEntityTransferer.js.map
